export const ENV_DEMO = "demo"